import {h} from 'preact'

export default function Card(props) {
  return (
    <div className="w-24 h-24 lg:w-32 lg:h-32 bg-gray-200 shadow-xs my-0 mr-4 md:mr-5 ml-0 rounded transform scale-100 group-hover:scale-110 transition-transform ease-in-out duration-200  ratio-container ratio1x1">
      <img
        className="media-box__image lazyload"
        alt={props.altTitle}
        data-src={props.imageSrc}
        data-srcSet={props.imageSrcset}
      />
    </div>
  );
}
